import TimezoneTypes from 'store/actionTypes/timezone'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const timezone = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case TimezoneTypes.GET_TIMEZONES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case TimezoneTypes.GET_TIMEZONE_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case TimezoneTypes.UPDATE_FILTER_TIMEZONE_SUCCESS:
      return { ...state, filter: payload }

    case TimezoneTypes.GET_SYSTEM_TIMEZONES_SUCCESS:
      return { ...state, systems: payload?.timezones?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default timezone
